import LabelFooter from "components/common/Chart/LabelFooter";
import useHelper from "hook/useHelper";
import { useState } from "react";
import { useSelector } from "react-redux"
import ChartColumn from "./ChartColumn"
import { options1 } from './ChartColumnConfig1';

export default function LeftChartColumn() {
  const AnalysisStore = useSelector((state: any) => state?.AnalysisStore)
  const [FilterLabel, setFilterLabel] = useState<any>([])
  const { handleFilterArray } = useHelper();

  const handleChangeFilterLabel = (value: string) => {
    const FilterLabelNew: any = handleFilterArray(value, FilterLabel)
    setFilterLabel([...FilterLabelNew])
  }

  return (
    <div className='rkfsexNgSP'>
      <div className='eLARzutcUp'>
        <div className='FBYLsQFKIN'>Back-test lợi nhuận trong kỳ của nhóm cổ phiếu đảm bảo tiêu chí:</div>
        <div className='LtkbJSiSFP'>
          <div className='TKfYvcyDUt'>
            <span className='TmHfNzhYpG'>Tăng trưởng:</span>
            <span className='jUmqKvrUAO'>{AnalysisStore?.backtest?.detailBacktest?.growthRank}</span>
          </div>
          <div className='vDYBzetbGf'>
            <span className='xLrKnmDvpo'>Động lượng:</span>
            <span className='zPjquGVwff'>{AnalysisStore?.backtest?.detailBacktest?.momentumRank}</span>
          </div>
        </div>
      </div>
      <div className='QxKLLZnAVX'>
        <ChartColumn options={options1(AnalysisStore?.backtest)} />
        <LabelFooter selectData={(value: string) => handleChangeFilterLabel(value)}
          listDefault={FilterLabel}
          data={[
            { name: 'LN trung bình nhóm', color: '#2C69B9' },
            { name: 'LN cao nhất nhóm', color: '#22AB24' },
            { name: 'LN thấp nhất nhóm', color: '#FF0012' },
          ]} />
      </div>
    </div>
  )
}